import api from '../request'

const processAfterSale = (afterSaleInfo, comment, warehouseCode, printerCode, printQualifiedCert = false) => {
    return api.postPromise('erp/afterSale/processAfterSale', {
        comment, warehouseCode, printerCode, printQualifiedCert
    }, afterSaleInfo)
}

const receiveIntercept = (waybillId, originWaybillId, deviceId, warehouseCode, isYiboSend, items, printQualifiedCert = false) => {
    return api.postPromise('erp/afterSale/receiveIntercept', {
        waybillId, originWaybillId, deviceId, warehouseCode, isYiboSend, printQualifiedCert
    }, items)
}

const unusualRecordNew = (waybillId, unusual, warehouseCode, description, confirm, items) => {
    return api.postPromise('erp/afterSale/unusualRecordNew', {
        waybillId, unusual, warehouseCode, description, confirm
    }, items)
}

const finishUnusualNew = (id, finishType) => {
    return api.getPromise('erp/afterSale/finishUnusualNew', {
        id, finishType
    })
}

const updateAfterSaleEntryOrderItems = (entryOrderId, items) => {
    return api.postPromise('erp/afterSale/updateAfterSaleEntryOrderItems', {
        entryOrderId
    }, items)
}

const reprintAfterSaleLabel = (entryOrderId, deviceId, items) => {
    return api.postPromise('erp/afterSale/reprintAfterSaleLabel', {
        entryOrderId, deviceId
    }, items)
}

const printTagLabelForEntryOrder = (entryOrderId, deviceId) => {
    return api.getPromise('entryOrder/printTagLabelForEntryOrder', {
        entryOrderId, deviceId
    })
}

const transform2Defective = (qrText, deviceId, warehouseCode, defective, hasTransformed) => {
    return api.postPromise('erp/afterSale/transform2Defective', {
        qrText, deviceId, warehouseCode, defective, hasTransformed
    })
}

const createDefectiveEntryOrder = (genuineEntryOrderId, defectiveEntryOrderId, waybillId, teamId, warehouseCode, items) => {
    return api.postPromise('erp/afterSale/createDefectiveEntryOrder', {
        genuineEntryOrderId, defectiveEntryOrderId, waybillId, teamId, warehouseCode
    }, items)
}

const toDefective = (entryOrderId, qrText, defective, warehouseCode, deviceId) => {
    return api.getPromise('erp/afterSale/toDefective', {
        entryOrderId,
        qrText,
        defective,
        warehouseCode,
        deviceId
    })
}

const createAfterSaleEntryOrder = (entryOrderDto) => {
    return api.postPromise('erp/afterSale/createAfterSaleEntryOrder', {}, entryOrderDto)
}

const closeAfterSaleEntryOrder = (order) => {
    return api.postPromise('erp/afterSale/closeAfterSaleEntryOrder', {}, order)
}


export default {
    processAfterSale,
    receiveIntercept,
    unusualRecordNew,
    finishUnusualNew,
    updateAfterSaleEntryOrderItems,
    reprintAfterSaleLabel,
    transform2Defective,
    createDefectiveEntryOrder,
    toDefective,
    createAfterSaleEntryOrder,
    closeAfterSaleEntryOrder,
    printTagLabelForEntryOrder
}



// WEBPACK FOOTER //
// ./src/request/newSys/erpAfterSaleApi.js